import {
  assemblyClientDomainHostname,
  assemblyPrimaryDomainHostname,
  copilotClientDomainHostname,
  copilotPrimaryDomainHostname,
} from './hostnameConsts';

export const copilotDashboardSubdomain = 'dashboard' as const;
export const assemblyDashboardSubdomain = 'dashboard' as const;

// copilot hostnames
export const copilotDashboardHostnameProd =
  `${copilotDashboardSubdomain}.${copilotPrimaryDomainHostname.prod}` as const;
export const copilotDashboardHostnameStaging =
  `${copilotDashboardSubdomain}.${copilotPrimaryDomainHostname.staging}` as const;

// copilot client domains
export const copilotClientDomainProd = copilotClientDomainHostname.prod;
export const copilotClientDomainStaging = copilotClientDomainHostname.staging;

// copilot client user domains
export const copilotClientDomains = [
  copilotClientDomainProd,
  copilotClientDomainStaging,
  '127.0.0.1',
];

// assembly hostnames
export const assemblyDashboardHostnameProd =
  `${assemblyDashboardSubdomain}.${assemblyPrimaryDomainHostname.prod}` as const;
export const assemblyDashboardHostnameStaging =
  `${assemblyDashboardSubdomain}.${assemblyPrimaryDomainHostname.staging}` as const;

// assembly client domains
export const assemblyClientDomainProd = assemblyClientDomainHostname.prod;
export const assemblyClientDomainStaging = assemblyClientDomainHostname.staging;

// assembly client user domains
export const assemblyClientDomains = [
  assemblyClientDomainProd,
  assemblyClientDomainStaging,
  '127.0.0.1',
];

export const prodClientUserDomain = copilotClientDomainHostname.prod;
export const devClientUserDomain = copilotClientDomainHostname.staging;

// combined client domains for backward compatibility
export const allClientUserDomains = [
  ...copilotClientDomains,
  ...assemblyClientDomains,
];
